import { render, staticRenderFns } from "./VlFilterHeader.vue?vue&type=template&id=3987d752&scoped=true&"
import script from "./VlFilterHeader.vue?vue&type=script&lang=js&"
export * from "./VlFilterHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987d752",
  null
  
)

export default component.exports